export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export interface MagicRequest {
  url: string;
  method: RequestMethod;
  headers: Headers;
  body?: BodyInit;
  companyId?: string;
}
